import React, { useEffect, useState } from "react";
import axios from "axios";
import { createScenarioData, updateScenarioData } from "../api/scenarioData";
import ActiveStatusFilter from "../components/shared/ActiveStatusFilter";

export default function IncidentTypeManager() {
  const [incidentTypes, setIncidentTypes] = useState([]);
  const [form, setForm] = useState({ name: "", active: true });
  const [editingId, setEditingId] = useState(null);
  const [message, setMessage] = useState(null);
  const [showActive, setShowActive] = useState(true);

  const showMessage = (type, text) => {
    setMessage({ type, text });
    setTimeout(() => setMessage(null), 4000);
  };

  const loadIncidentTypes = async () => {
    const res = await axios.get("/api/digital-risk/incident-types/");
    setIncidentTypes(res.data);
  };

  useEffect(() => {
    loadIncidentTypes();
  }, []);

  const saveIncidentType = async () => {
    try {
      if (!form.name.trim()) {
        showMessage("error", "Incident type name is required.");
        return;
      }

      if (editingId) {
        await updateScenarioData("incidentTypes", editingId, form);
        showMessage("success", "Incident type updated successfully.");
      } else {
        await createScenarioData("incidentTypes", form);
        showMessage("success", "Incident type created successfully.");
      }

      setForm({ name: "", active: true });
      setEditingId(null);
      await loadIncidentTypes();
    } catch (error) {
      showMessage("error", "Unable to save incident type.");
      console.error(error.response?.data || error);
    }
  };

  const editIncidentType = (item) => {
    setEditingId(item.id);
    setForm({
      name: item.name,
      active: item.active,
    });
  };

  return (
    <div className="p-6 space-y-6">
      {/* 
      <div className="bg-sky-950 text-white rounded-3xl p-7 shadow-sm">
        <p className="text-xs uppercase tracking-[0.25em] text-slate-400">
          Scenario Modeling
        </p>

        <div className="flex flex-col xl:flex-row xl:items-end xl:justify-between gap-6 mt-3">
          <div>
            <h1 className="text-3xl font-bold">
              Incident Type Manager
            </h1>

            <p className="text-slate-300 mt-2 max-w-3xl">
              Manage governed incident categories used by digital risk scenarios.
            </p>
          </div>

        </div>
      </div>
      */}
      {message && (
        <div
          className={`px-4 py-3 rounded-xl text-sm font-medium ${
            message.type === "success"
              ? "bg-green-100 text-green-800 border border-green-200"
              : "bg-red-100 text-red-800 border border-red-200"
          }`}
        >
          {message.text}
        </div>
      )}

      <div className="bg-white border rounded-2xl p-5">
        <h2 className="font-semibold mb-4">
          {editingId ? "Edit Incident Type" : "New Incident Type"}
        </h2>

        <div className="flex flex-col md:flex-row gap-4">
          <input
            value={form.name}
            onChange={(e) =>
              setForm({ ...form, name: e.target.value })
            }
            placeholder="Incident type name"
            className="border rounded-xl px-4 py-3 flex-1"
          />

          <label className="flex items-center gap-2 text-sm">
            <input
              type="checkbox"
              checked={form.active}
              onChange={(e) =>
                setForm({ ...form, active: e.target.checked })
              }
            />
            Active
          </label>

          <button
            onClick={saveIncidentType}
            className="bg-slate-900 text-white px-5 py-3 rounded-xl"
          >
            {editingId ? "Update" : "Create"}
          </button>

          {editingId && (
            <button
              onClick={() => {
                setEditingId(null);
                setForm({ name: "", active: true });
              }}
              className="border px-5 py-3 rounded-xl"
            >
              Cancel
            </button>
          )}
        </div>
      </div>

      <div className="bg-white border rounded-2xl p-5">
        <h2 className="font-semibold mb-4">Incident Types</h2>
        <ActiveStatusFilter value={showActive} onChange={setShowActive} />

        <table className="w-full text-sm">
          <thead>
            <tr className="border-b text-gray-500">
              <th className="text-left py-3">Name</th>
              <th className="text-left py-3">Status</th>
              <th className="text-left py-3">Actions</th>
            </tr>
          </thead>

          <tbody>
            {incidentTypes.filter((item) => item.active === showActive).map((item) => (
              <tr key={item.id} className="border-b">
                <td className="py-3 font-medium">{item.name}</td>
                <td className="py-3">
                  {item.active ? "Active" : "Inactive"}
                </td>
                <td className="py-3">
                  <button
                    onClick={() => editIncidentType(item)}
                    className="text-slate-700 hover:text-black"
                  >
                    Edit
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
